import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { edcUrls } from "../../URL/ApplicationUrls";
import EdcSelectionItem from "../EdcSelectionItem";
import { minutesAsMilliSeconds } from "../../Utils/time";

export const useFetchEdcSelectionItems = () => {
  return useQuery<EdcSelectionItem[], Error>({
    queryKey: "edcs",
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchEdcSelectionItems(),
    onError: () => {
      toast.error(`An error occurred when retrieving EDCs`);
    },
  });
};

const fetchEdcSelectionItems = async () => {
  const { data: edcItems } = await axios.get<EdcSelectionItem[]>(edcUrls.selectableEdc.apiUrl);
  return edcItems;
};
